// @flow
import { getFirstElement } from 'clark-utils';

export const getUserPaymentMethodByType = (
  payer: any,
  paymentMethods: any,
  paymentMethodType: any,
) => {
  const { relationships = {} } = getFirstElement(payer);
  const relationshipName =
    paymentMethodType === 'bankAccount' ? 'bankAccountPaymentMethod' : 'creditCardPaymentMethod';

  const relationshipsOfThatType = relationships[relationshipName] || { data: [{}] };
  const { data: dataOfThatType = [{}] } = relationshipsOfThatType;
  const [{ id: paymentMethodId } = {}] = dataOfThatType;

  return paymentMethods && paymentMethods[paymentMethodId];
};

export const getCorrectUserPaymentMethod = (
  payer: any,
  paymentMethods: any,
  chargePaymentMethodType: any,
) => {
  const bankAccountPaymentMethod = getUserPaymentMethodByType(payer, paymentMethods, 'bankAccount');
  const creditCardPaymentMethod = getUserPaymentMethodByType(payer, paymentMethods, 'creditCard');

  // the second '||' below when setting paymentMethod provides compatibility with existing API
  // so we could release this without the API update for ACH going out ahead of time;
  // it can be safely removed after the backend goes out
  // - MP 10.25.2018
  const paymentMethod =
    chargePaymentMethodType === 'bankAccount'
      ? bankAccountPaymentMethod
      : creditCardPaymentMethod || (paymentMethods && getFirstElement(paymentMethods));

  return paymentMethod;
};



// WEBPACK FOOTER //
// ./src/utils/payment-method.js